import React, { useEffect, useState } from "react";
import Boop from "common/Boop";
import useEventListener from "utils/hooks/useEventListener";

const element = ({
  image,
  logMessage,
  imageStyle = { maxHeight: 80, maxWidth: 80 },
  key,
}) => (
  <div key={key} className="pointer-events-auto">
    <Boop rotation={20} mass={2}>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */}
      <img
        alt="an easter egg"
        className="rounded-2xl"
        style={imageStyle}
        src={image}
        onClick={() => {
          if (logMessage) {
            console.log(logMessage);
          }
        }}
      />
    </Boop>
  </div>
);

const useEasterEgg = (eggs) => {
  const [inputs, setInputs] = useState([]);
  const [shownEggs, setShownEggs] = useState([]);

  const handler = (event) => {
    const { key } = event;
    const newInputs = [...inputs];
    newInputs.push(`${key}`);
    setInputs(newInputs);
  };

  useEffect(() => {
    setShownEggs([
      ...shownEggs,
      ...eggs
        .filter(
          (egg) =>
            !shownEggs.map((shownEgg) => shownEgg.string).includes(egg.string),
        )
        .filter((egg) => inputs.join("").includes(egg.string)),
    ]);
  }, [inputs]);

  // useEventListener("keydown", handler);

  return {
    eggs: (
      <div className="fixed bottom-0 right-0 flex justify-end flex-wrap gap-x-2 py-2 px-4 pointer-events-none">
        {shownEggs.map((egg, index) =>
          element({ ...egg, index, key: egg.string }),
        )}
      </div>
    ),
  };
};

export default useEasterEgg;
